import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next/hooks";
import Img from "react-cool-img";

import Button from "../../Button/Button";
import GroupInfoMemberItem from "./GroupInfoMemberItem";
import GroupInfoModal from "./GroupInfoModal";
import Loader from '../../Loader/Loader';

import { useStore } from "../../../hook-store/store";
import { getLocalTimeElements } from "../../../util/timeFormat";
import { getUserDescription, getUserImageUrl } from "../../../util/user";
import { getGroupRoomInUsersHandler, } from "../../../util/group/group-socket-handlers";

import SampleImage from "../../Image/person-icon-50.jpg";


import classes from './GroupInfoMemberList.module.css'

import { GQL_URL, BASE_URL } from "../../../App";

const GroupInfoMemberList = (props) => {
  // console.log("GroupInfoMemberList-props", props);

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  const {
    userData,
  } = store;
  const { 
    socketState,
    selectedGroupData,
    groupRoomInUsersData,
    isGroupMember,
  } = store.groupStore;
  // console.log('store in GroupInfoMemberList', store);

  const [showAllMembers, setShowAllMembers] = useState(false);
  const [showSmallModal, setShowSmallModal] = useState(false);
  const [userDescription, setUserDescription] = useState("");
  const [selectedUserId, setSelectedUserId] = useState("");
  const [memberImageUrlList, setMemberImageUrlList] = useState([]);
  const [confirmMemberDelete, setConfirmMemberDelete] = useState(false);

  useEffect(() => {
    if (props.allMemberUserIds && props.allMemberUserIds.length > 0) {
      getUserImageUrlsHandler();
    }
  }, [props.allMemberUserIds, props.allMemberUserIds]);

  //// get group room in users data when open
  useEffect(() => {
    if (showSmallModal) {
      getGroupRoomInDataHandler(
        userData,
        selectedGroupData,
        isGroupMember,
        socketState,
        groupRoomInUsersData,
      );
    }
  },[showSmallModal]);



  let isCreator = false;
  if (
    props.userId &&
    props.groupInfo &&
    props.userId === props.groupInfo.creatorUserId
  ) {
    isCreator = true;
  }

  const showAllMembersHandler = () => {
    setShowAllMembers(!showAllMembers);
  };

  const hideAllMembersHandler = () => {
    setShowAllMembers(false);
  };

  const showSmallModalHandler = () => {
    setShowSmallModal(!showSmallModal);
  };

  const setSelectedUserIdHandler = (userId) => {
    if (selectedUserId === userId) {
      setSelectedUserId("");
    } else {
      setSelectedUserId(userId);
    }
  };

  const getUserDescriptionHandler = (userId) => {
    setUserDescription("");

    if (!selectedUserId || selectedUserId !== userId) {
      getUserDescription(BASE_URL, localStorage.getItem("token"), userId)
        .then((res) => {
          console.log(res);

          setUserDescription(res.data.user.description);
          setSelectedUserIdHandler(userId);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getUserImageUrlsHandler = async () => {
    const imageUrlsList = [];

    for (const member of props.allMemberUserIds) {
      if (member.imagePath) {
        const userImageUrl = await getUserImageUrl(
          BASE_URL,
          localStorage.getItem("token"),
          member.userId
        );
        if (userImageUrl) {
          imageUrlsList.push(userImageUrl);
        }
      }
    }
    // console.log('imageUrlsList', imageUrlsList);

    if (imageUrlsList.length > 0) {
      setMemberImageUrlList(imageUrlsList);
      dispatch("SET_GROUPMEMBER_IMAGEURLS", imageUrlsList);
    }
  };


  const getGroupRoomInDataHandler = (
    userData,
    selectedGroupData,
    isGroupMember,
    socketState,
    groupRoomInUsersData,
  ) => {
    if (selectedGroupData && userData && isGroupMember && socketState) {

      //// different groupRoomId case
      if (!groupRoomInUsersData || 
          groupRoomInUsersData.groupRoomId !== selectedGroupData._id
      ) {
        getGroupRoomInUsersHandler(
          socketState,
          userData.userId,
          selectedGroupData._id,
        );
      }

      if (groupRoomInUsersData && groupRoomInUsersData.groupRoomId === selectedGroupData._id) {
          getGroupRoomInUsersHandler(
            socketState,
            userData.userId,
            selectedGroupData._id,
          );
      }
    }
  };


  let allMembers;
  if (props.allMemberUserIds && props.allMemberUserIds.length > 0) {

    if (!localStorage.getItem('userId')) {
      allMembers = (
        <div>Group members info will be shown after login.</div>
      );
    } else {

      const lsNameDataList = localStorage.getItem('lsNameDataList');
  
      allMembers = (
        <div>
          <ul>
            {props.allMemberUserIds.map((member) => {
              // console.log(member);
              // const isOnline = props.joinGroupOnlineMember.find((element) => {
              //   return element.userId === member.userId;
              // });
  
              // const userInfo = props.usersData.find(element => {
              //   return element.userId === member.userId;
              // });
  
              const userInfo2 = props.allMemberUserIds.find((element) => {
                return element.userId === member.userId;
              });
  
              const userCreateDate = getLocalTimeElements(member.createdAt)
                .dateDisplay;
              // console.log(userCreateDate);
  
              const joinDate = getLocalTimeElements(userInfo2.addAt).dateDisplay;
              // console.log(getLocalTimeElements(joinDate));
  
              let userImageUrl;
              if (memberImageUrlList.length > 0) {
                const imageUser = memberImageUrlList.find((ele) => {
                  return ele.userId === member.userId;
                });
                // console.log('imageUser', imageUser);
                if (imageUser) {
                  userImageUrl = imageUser.imageUrl;
                }
              }
  
              let nameData;
              if (lsNameDataList && JSON.parse(lsNameDataList).length > 0) {
                nameData = JSON.parse(lsNameDataList).find(ele => {
                  return ele.userId === member.userId;
                });
              }
  
              return (
                  <div>
                    <div
                      key={member.userId}
                      onClick={() => {
                        getUserDescriptionHandler(member.userId);
                        setSelectedUserIdHandler(member.userId);
                      }}
                    >
                      <GroupInfoMemberItem 
                        member={member}
                        selectedUserId={selectedUserId}
                        userDescription={userDescription}
                      />
                    </div>
                  </div>
              );
            })}
          </ul>
        </div>
      );
    }
  }

  let groupMemberBody;

  groupMemberBody = (
    <div 
    // className="groupTalkTextList-groupNameContainer"
    >
      <div 
      // className="groupTalkTextList-groupName"
      >
        {/* {props.groupInfo.groupName} */}
      </div>
      
      {!props.isLoading && 
        <div
          // className="groupTalkTextList-showMemberButton"
          onClick={() => {
            showAllMembersHandler();
            showSmallModalHandler();
          }}
        >
          {t("groupTalk.text19", "Display Group Members")} &#9662;
        </div>
      }

      {/* {showSmallModal && (
        <GroupInfoModal
          showModalHandler={showSmallModalHandler}
          modalContent={allMembers}
        />
      )} */}
      {showSmallModal && (
        <div>{allMembers}</div>
      )}
    </div>
  );

  if (props.isLoading) {
    // groupMemberBody = null;
  }

  return (
    <div>
      <div id="group-info" 
      // className="groupTalkTextList-groupInfo"
      >
        {groupMemberBody}
      </div>
    </div>
  );
};

export default GroupInfoMemberList;
